{
  "version": 1,
  "asset_id": "02b57355-6139-4373-b1c3-eec5863b3f27",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/02b57355-6139-4373-b1c3-eec5863b3f27/bypass-normal-boxed-es-480.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/02b57355-6139-4373-b1c3-eec5863b3f27/bypass-normal-boxed-es-480.jpg",
  "original_filename": "bypass-normal-boxed-es-480.jpg",
  "size": 22035,
  "content_type": "image/jpeg",
  "created_at": "2026-10-06T14:11:25Z"
}
